import React from "react"
import { graphql } from "gatsby"
import chunk from "lodash/chunk"

import Layout from "../components/layout"
import ListPost from "../components/listPost"
import TagSearch from "../components/tagSearch"
import SEO from "../components/seo"

import "../assets/styles/index.scss"

if (typeof window !== `undefined`) window.postsToShow = 3

class IndexPage extends React.Component {

  state = {
    postsToShow: 3,
    showingMore: false
  }

  update = () => {
    const distanceToBottom =
      document.documentElement.offsetHeight -
      (window.scrollY + window.innerHeight)
    if (this.state.showingMore && distanceToBottom < 750) {
      this.setState({ postsToShow: this.state.postsToShow + 3 })
    }
    this.ticking = false
  }

  handleScroll = () => {
    if (!this.ticking) {
      this.ticking = true
      requestAnimationFrame(() => this.update())
    }
  }

  ditoTrack() {
    window.dito.track({
      action: 'acessou-home',
    });
  }

  componentDidMount() {
    this.ditoTrack()

    /* Limit Posts */
    let postsToShow = 3
    let numberOfPosts = this.props.data.allMarkdownRemark.edges
    if (typeof window !== `undefined`) {
      postsToShow = window.postsToShow
    }
    if (numberOfPosts.length <= postsToShow) {
      this.setState({
        showingMore: true
      })
    } else {
      this.setState({
        showingMore: postsToShow > 3,
        postsToShow
      })
    }
    window.addEventListener(`scroll`, this.handleScroll)
  }

  componentWillUnmount() {
    window.removeEventListener(`scroll`, this.handleScroll)
    window.postsToShow = this.state.postsToShow
  }

  renderPosts() {
    //Renderizar Post
    const { data } = this.props;
    const posts = data.allMarkdownRemark.edges
    return (
      chunk(posts.slice(0, this.state.postsToShow)).map(
        (chunk) =>
          chunk.map(post => (
            <div key={post.node.id} className="post">
              <ListPost
                link={post.node.fields.slug}
                img={post.node.frontmatter.img.childImageSharp.fluid}
                title={post.node.frontmatter.title}
                description={post.node.frontmatter.description}
                date={post.node.frontmatter.date}
                tag={post.node.frontmatter.tags}
                author={post.node.frontmatter.author}
              />
            </div>
          ))))
  }

  render() {
    let tagSearch = <TagSearch group={this.props.data.allMarkdownRemark.group} />
    return (
      <Layout contentBg={tagSearch} location={this.props.location} >
        <SEO title="Home" keywords={[`gatsby`, `artigos`, `react`, `tecnologia`, `blog`, `dito`]} />
        <section id="home">
          <div className="container">
            <h2>Últimas Postagens</h2>
            <div className="divisor" />
            <div className="posts">
              {this.renderPosts()}
            </div>
            <div className="view-more">
              {!this.state.showingMore && (
                <div>
                  <button
                    aria-label="More Posts"
                    data-testid="load-more"
                    className="btn-more"
                    onClick={() => {
                      this.setState({
                        postsToShow: this.state.postsToShow + 3,
                        showingMore: true,
                      })
                    }}
                  >
                    Veja Mais <b>+</b>
                  </button>
                  <hr />
                </div>
              )}
            </div>

          </div>
        </section>
      </Layout >
    );
  }
}

export const pageQuery = graphql`
  query IndexQuery {
    allMarkdownRemark(
      filter: { frontmatter: { published: { eq: true } } }
      sort: { fields: [frontmatter___date], order: DESC }
      ){
      group(field: frontmatter___tags) {
        fieldValue
      }
      edges {
        node {
          fields {
            slug
          }
          id
          frontmatter {
            title
            description
            author
            tags
            img{
              childImageSharp {
                fluid(maxWidth: 3000) {
                  ...GatsbyImageSharpFluid
                }
              }
            }          
            date(formatString: "MMM / YYYY")
          }
        }
      }
    }
  }
`

export default IndexPage
